import type { Locale } from '@/config/build';
import type { AppConfig } from '@/config/localized';

interface LoaderOptions {
  locale: Locale;
  environment: string;
  testingName?: string;
}

export async function loadConfig(options: LoaderOptions): Promise<AppConfig> {
  try {
    const paramContext = prepareParametersContext(options);
    const parametersFile = await import(`../../localized/${options.locale}/index.${options.environment}.ts`);
    const localizedConfigFile = await import(`../../localized/${options.locale}/index.ts`);

    return localizedConfigFile.default(parametersFile.default(paramContext), paramContext);
  } catch (error) {
    throw new Error(`Error while loading configuration: ${error instanceof Error ? error.message : String(error)}`);
  }
}

function prepareParametersContext(options: LoaderOptions) {
  return {
    locale: options.locale,
    testingName: options.environment === 'testing' ? options.testingName || 'undefined' : 'undefined',
  };
}
